/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

import useQueryAppender from '../../../hooks/useQueryAppender';
import styles from './styles.module.scss';

const SbaApplyHero = React.forwardRef(
  ({ post: { heroParagraph1 = '' }, location: { search = '' } }, ref) => {
    const appLink = useQueryAppender(
      'https://account.kabbage.com/create-account?product=sba-loan',
      search
    );

    const handleClick = e => {
      e.preventDefault();
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    };

    const handleOnKeyDown = e => {
      e.preventDefault();
      if (e.keyCode === 13) {
        ref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    };

    return (
      <>
        <section className={styles.section}>
          <div className="container">
            <div className={styles.content}>
              <h1 className={styles.header}>
                Apply for federal relief through the Paycheck Protection
                Program*
              </h1>
              <div className={styles.desc}>
                {heroParagraph1 ? (
                  parse(heroParagraph1)
                ) : (
                  <p>
                    Through the SBA&apos;s Paycheck Protection Program, small
                    businesses can apply for loans for payroll and other
                    eligible expenses.
                  </p>
                )}
              </div>
              <div className={styles.ctas}>
                <a href={appLink} className="pill-button large app-link green">
                  Apply now
                </a>
              </div>
              <a
                role="link"
                tabIndex={0}
                className={styles.annotation}
                onClick={handleClick}
                onKeyDown={handleOnKeyDown}
              >
                Make sure you have this <span>required documentation</span>{' '}
                ready
              </a>
            </div>
          </div>
        </section>
      </>
    );
  }
);

SbaApplyHero.propTypes = {
  post: PropTypes.shape({
    heroParagraph1: PropTypes.string,
  }),
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

SbaApplyHero.defaultProps = {
  post: {
    heroParagraph1: '',
  },
  location: {
    search: '',
  },
};

export default SbaApplyHero;
